export const LANGUAGE_FLAGS: Record<string, string> = {
  universal: "🌐",
  en: "🇬🇧",
  lt: "🇱🇹",
  ru: "🇷🇺",
  de: "🇩🇪",
  fr: "🇫🇷",
  pl: "🇵🇱",
  es: "🇪🇸",
  it: "🇮🇹",
  nl: "🇳🇱",
  pt: "🇵🇹",
  zh: "🇨🇳",
  ja: "🇯🇵",
  ko: "🇰🇷",
};

export function languageFlag(code: string | null | undefined): string | null {
  if (!code) return null;
  return LANGUAGE_FLAGS[code] ?? "🌐";
}
